const reportDB = require("../../../../../components/report/report-db");
const snack = require("../../../../../components/snack/snack");
const { printHtmlInIframe } = require("./reportHub-report-print");
const { generatePayableAll } = require("./reportHub-reportAll-template");
const { generatePayableOneDocument } = require("./reportHub-reportOne-template");

const PHP_REPORT = "server/php/report/report-pdf.php";

// Helper para mostrar errores de forma simplificada
const showError = (id = "downloadError") => snack.start({ act: "show", id });

// Constructor unificado del payload para las consultas (entidad: provider)
function buildDetail(report, filters, extraInf = {}) {
  const inf = { entity: "provider", report, ...extraInf };
  if (filters.startDate) inf.startDate = filters.startDate;
  if (filters.endDate) inf.endDate = filters.endDate;
  if (filters.useYear) inf.filterByYear = "1";
  
  return { inf };
}

export function getData(def, filters, helpers) {
  const actions = {
    "account-payable-all": () => runGeneratorAll(filters),
    "account-payable-one": () => runGeneratorOne(filters, helpers),
  };

  const action = actions[def.id];
  action ? action() : showError();
}

function runGeneratorAll(filters) {
  const detail = buildDetail("account-payable-all", filters);

  reportDB.select(detail, PHP_REPORT, (data) => {
    if (!data?.length) return showError();
    printHtmlInIframe(generatePayableAll(data));
  });
}

function runGeneratorOne(filters, helpers) {
  const dbid = filters.entityId || helpers.getSelectedProviderDbid();
  
  if (!dbid) return showError("reportHubNoProvider");

  const detailTop = buildDetail("account-payable-all-one", filters, { dbid });

  reportDB.select(detailTop, PHP_REPORT, (topData) => {
    if (!topData?.length) return showError();

    const detailLines = buildDetail("account-payable-one", filters, { id: dbid });

    reportDB.select(detailLines, PHP_REPORT, (tableData) => {
      printHtmlInIframe(generatePayableOneDocument(topData, tableData || []));
    });
  });
}